export default __webpack_public_path__ + "static/media/location.531cdd1e.png";